import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, signal, WritableSignal } from '@angular/core';
import { isExtension } from '@local/common-web';

@Component({
  selector: 'card-list',
  templateUrl: './card-list.component.html',
  styleUrls: ['./card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListComponent {
  private isExtension = isExtension();
  tooltipDisabled: WritableSignal<boolean> = signal(true);

  @Input() cards: string[];
  @Output() onClickCard = new EventEmitter<boolean>();

  @HostBinding('attr.isExtensionMode')
  get isExtensionMode() {
    return this.isExtension;
  }
  updateTooltip(element: HTMLElement) {
    const isTruncated = element.clientHeight < element.scrollHeight;
    this.tooltipDisabled.set(!isTruncated);
  }
}
